import { BlockProps } from "../../containers/Block";

export default function RSVP({ block }: BlockProps) {
  return <div>RSVP - {block.blockId}</div>;
}
